import { RootActionTypes } from '../../../stores/types';
import ActionTypes from '../constants/action-types';

export default function openLabsAcceptDialog(): RootActionTypes {
  return {
    type: ActionTypes.OPEN_ACCEPT_DIALOG,
  };
}
